/* eslint-disable @typescript-eslint/no-explicit-any */

import { AudioFile } from "./Content";
import { IListInformationPopup } from "./ListInformationPopup";
import { Author } from "./Social";


    export interface FeaturedImage {
        height: number;
        width: number;
        url: string;
        fileName: string;
        mediaType: string;
        size: number;
    }

    export interface FeaturedImage2 {
        height: number;
        width: number;
        url: string;
        fileName: string;
        mediaType: string;
        size: number;
    }

    export interface Image {
        height: number;
        width: number;
        url: string;
        fileName: string;
        mediaType: string;
        size: number;
    }

    export interface File {
        url: string;
        fileName: string;
        mediaType: string;
        size: number;
    }

    export interface Video {
        url: string;
        fileName: string;
        mediaType: string;
        size: number;
    }

    export interface FeaturedImage {  
        height: number
        width: number
        url: string
        fileName: string
        mediaType: string
        size: number
    }

    export interface Item2 {
        type: string;
        text: string;
        published: boolean;
        caption: string;
        contentUrl: string;
        image: Image;
        title: string;
        featuredImage: FeaturedImage;
        file: File;
        video: Video;
        html: string;
        contentId?: number;
        audioFile?: AudioFile;
    }

    export interface Image2 {
        height: number;
        width: number;
        url: string;
        fileName: string;
        mediaType: string;
        size: number;
    }

    export interface File2 {
        url: string;
        fileName: string;
        mediaType: string;
        size: number;
    }

    export interface Video2 {
        url: string;
        fileName: string;
        mediaType: string;
        size: number;
    }

    export interface Item {
        id: number;
        type: string;
        title: string;
        contentUrl: string;
        featuredImage: FeaturedImage2 | undefined;
        location?: unknown;
        version: number;
        author: Author,
        timeStamp: Date | string;
        publishDate: string;
        modifiedDate: string;
        likingEnabled: boolean;
        socialInfoUrl: string;
        commentingEnabled: boolean;
        items: Item2[] | undefined;
        shareLink?: string;
        links?: any;
        fromCache: boolean;
        acknowledgementsEnabled: boolean;
        acknowledgementsType?: string;
        acknowledgementsButtonText?: string;
        externalApiReference?: string;
        autoArchiveDate?: string;
        image: Image2 | undefined;
        description: string;
        file: File2 | undefined;
        video: Video2 | undefined;
        nextUrl?: string;
        previousUrl?: string;
        displayHero?: boolean;
        layout: string;
        displayDateType: string;
        sortType: string;
        displayIcons?: boolean;
        postFormUrl?: string;
        postButtonText?: string;
        thanksTargetGroup: string;
        displayGradients?: boolean;
        feedUrl: string;
        displayDate: string;
        subtitle: string;
        telephone: string;
        mobile: string;
        email: string;
        webSite: string;
        address1: string;
        address2: string;
        townCity: string;
        stateCounty: string;
        country: string;
        postalCode: string;
        vcardUrl?: string;
        webUrl: string;
        useExternalBrowser?: boolean;
        itemUrl:string;
        heroType: string | undefined;
        audioFile?: AudioFile;
    }

    export interface ListRoot {
        id: number;
        type: string;
        title: string;
        contentUrl: string;
        featuredImage: FeaturedImage;
        location?: any;
        version: number;
        timeStamp: Date;
        publishDate: Date;
        modifiedDate: Date;
        likingEnabled: boolean;
        socialInfoUrl: string;
        commentingEnabled: boolean;
        items: Item[];
        nextUrl?: string;
        previousUrl?: string;
        displayHero: boolean;
        layout: listLayout;
        displayDateType: string;
        sortType: string;
        displayIcons: boolean;
        postFormUrl?: string;
        postButtonText?: string;
        thanksTargetGroup: string;
        displayGradients: boolean;
        shareLink?: string;
        links?: any;
        fromCache: boolean;
        acknowledgementsEnabled: boolean;
        acknowledgementsType?: string;
        acknowledgementsButtonText?: string;
        externalApiReference?: string;
        autoArchiveDate?: string;
        heroType: string;
        infoModal?: IListInformationPopup;
    }

    export enum listLayout {
        smallList = "smallList",
        mediumList = "mediumList",
        twocolumnList = "twocolumnList",
        polaroid =  "polaroid", //  Large mag on API
        polaroidMini =  "polaroidMini", /* New */
        gallery = "gallery",
        letterbox = "letterbox", 
        headline = "headline", /* New */
        feedMag = "feedMag", // FeedList
        socialList = "socialList",
        
        // Obsolete
        smallMag = "smallMag"
    }
    
export enum SocialListWidgetType {
    textWidget = "textWidget",
    imageWidget = "imageWidget",
    videoWidget = "videoWidget",
    audioWidget = "audioWidget",
    carouselWidget = "carouselWidget"
}

export interface ISocialListSocial {
    contentId: number;
    likingEnabled?: boolean;
    commentingEnabled?: boolean;
    totalLikes: number | null;
    totalComments: number | null;
    userLiked?: boolean;
}